import * as React from "react";

function SvgAeroplane(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512.043 512.043"
      width="1em"
      height="1em"
      {...props}
    >
      <path d="M496.469 353.365l-197.781-197.76V67.904c0-13.845-3.072-27.797-9.131-40.811l-4.501-8.533C279.744 7.104 268.629 0 256.021 0s-23.723 7.104-28.8 18.069l-4.971 9.493c-5.824 12.544-8.896 26.475-8.896 40.341v87.701L15.637 353.323C5.568 363.392.021 376.768.021 391.019v25.003c0 3.904 2.133 7.488 5.547 9.344a10.6 10.6 0 0010.88-.384L217.493 296.15c1.984 32.277 4.672 59.221 7.957 92.011l3.392 33.6-74.688 49.344c-3.008 2.005-4.8 5.333-4.8 8.917v21.333c0 3.221 1.472 6.293 3.989 8.32a10.605 10.605 0 008.981 2.112l93.696-20.843 93.696 20.843c.768.171 1.536.256 2.304.256a10.66 10.66 0 006.677-2.347c2.517-2.048 3.989-5.12 3.989-8.341v-21.333c0-3.584-1.792-6.933-4.8-8.896l-74.688-49.28 3.392-33.707c3.285-32.747 5.973-59.669 7.957-91.947l201.045 128.789a10.613 10.613 0 0010.859.384 10.611 10.611 0 005.568-9.344v-25.003c.002-14.25-5.523-27.626-15.55-37.653z" />
    </svg>
  );
}

export default SvgAeroplane;
